import { useRef, useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { BsCheckCircle, BsArrowRight, BsExclamationTriangle, BsClock } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import TextInput from '#globalComponents/Forms/TextInput';

const ActivityCompletionControls = ({ activity, dueDate, isOverdue, onComplete, onUpdate }) => {
	const [showReschedule, setShowReschedule] = useState(false);
	const [rescheduleDraft, setRescheduleDraft] = useState('');
	const rescheduleRef = useRef(null);

	useEffect(() => {
		if (!showReschedule) return;
		const handleClick = (e) => {
			if (rescheduleRef.current && !rescheduleRef.current.contains(e.target)) {
				setShowReschedule(false);
			}
		};
		document.addEventListener('mousedown', handleClick);
		return () => document.removeEventListener('mousedown', handleClick);
	}, [showReschedule]);

	return (
		<>
			{isOverdue && (
				<div className="mx-5 mb-3 px-3 py-2 bg-warning-200 rounded-card flex items-center gap-2 text-[12px] text-warning-700 font-medium">
					<BsExclamationTriangle className="w-3.5 h-3.5 flex-shrink-0" />
					Überfällig seit {Math.floor((new Date() - dueDate) / 86400000)} Tagen
				</div>
			)}

			<div className="flex items-center gap-1.5 px-5 pb-4">
				{activity.status !== 'completed' && (
					<>
						<div className="relative" ref={rescheduleRef}>
							<Button
								onClick={() => {
									setRescheduleDraft(
										dueDate
											? `${dueDate.getFullYear()}-${String(dueDate.getMonth() + 1).padStart(2, '0')}-${String(dueDate.getDate()).padStart(2, '0')}T${String(dueDate.getHours()).padStart(2, '0')}:${String(dueDate.getMinutes()).padStart(2, '0')}`
											: '',
									);
									setShowReschedule((s) => !s);
								}}
								variant="outline"
								size="sm"
							>
								<BsClock className="w-3 h-3" /> Verschieben
							</Button>
							{showReschedule && (
								<div className="absolute top-[calc(100%+6px)] left-0 z-40 bg-white border border-bgBase-500 rounded-card shadow-elevated p-3 min-w-[220px]">
									<label className="block text-[11px] font-semibold text-bgBase-800 mb-1.5">
										Neues Fälligkeitsdatum
									</label>
									<TextInput
										type="datetime-local"
										value={rescheduleDraft}
										onChange={(e) => setRescheduleDraft(e.target.value)}
									/>
									<Button
										type="button"
										variant="solid"
										size="sm"
										disabled={!rescheduleDraft}
										onClick={() => {
											onUpdate(activity.id, { dueAt: new Date(rescheduleDraft).toISOString() });
											setShowReschedule(false);
										}}
										className="w-full mt-2"
									>
										Speichern
									</Button>
								</div>
							)}
						</div>
						<Button onClick={(e) => onComplete(e, activity)} variant="outline" size="sm">
							<BsCheckCircle className="w-3 h-3" /> Erledigt
						</Button>
					</>
				)}
				{activity.status === 'completed' && (
					<Button onClick={(e) => onComplete(e, activity)} variant="outline" size="sm">
						<BsArrowRight className="w-3 h-3" /> Wieder öffnen
					</Button>
				)}
			</div>
		</>
	);
};

ActivityCompletionControls.propTypes = {
	activity: PropTypes.object.isRequired,
	dueDate: PropTypes.instanceOf(Date),
	isOverdue: PropTypes.bool.isRequired,
	onComplete: PropTypes.func.isRequired,
	onUpdate: PropTypes.func.isRequired,
};

export default ActivityCompletionControls;
